import { render } from "./XmarkIcon.vue?vue&type=template&id=083a8def"
import script from "./XmarkIcon.vue?vue&type=script&lang=js"
export * from "./XmarkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__